import printBarcodesComponent from './print_barcodes.component';

let printBarcodesModule = angular.module('printBarcodes', [
])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$urlRouterProvider.otherwise('/order-packing');

		$stateProvider
			.state('printBarcodes', {
				url: '/print-barcodes',
				component: 'printBarcodes',
				data: {
					requireLogin: true,
					requireACL: 'order_packing.all'
				},
			});
	})

	.component('printBarcodes', printBarcodesComponent)

	.name;

export default printBarcodesModule;




// WEBPACK FOOTER //
// ./client/app/components/order_packing/print_barcodes/index.js